// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var extendObservable = require('mobx').extendObservable;
  var action = require('mobx').action;
  var SchedulingSearchRow = require('./Izenda.SchedulingSearchRow');
  var CONSTANTS = require('logic/data/Izenda.SchedulingSearchConstants');
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');
  var DEFAULT_SORT_ORDER = CONSTANTS.DEFAULT_SORT_ORDER;
  const { clone, some, findIndex, map, times } = require('lodash/fp');

  function SchedulingSearchGrid(data, pageInfo) {
    var colSortDirs = pageInfo && pageInfo.colSortDirs;

    extendObservable(this, {
      pageInfo: new PagingModel(colSortDirs || clone(DEFAULT_SORT_ORDER)),
      tenantId: null,
      tenantName: null,
      schedules: [],
      isAllChecked: function() {
        return !some({ selected: false }, this.schedules);
      },
      isOneChecked: function() {
        return some({ selected: true }, this.schedules);
      },
      isEmpty: function() {
        return this.schedules.length === 0;
      }
    });

    data && this.populateData(data, pageInfo);
  }

  /**
   * Populate data
   * @param {object} data
   */
  SchedulingSearchGrid.prototype.populateData = action(function(data) {
    this.pageInfo.setPageIndex(data.pageIndex);
    this.pageInfo.setPageSize(data.pageSize);
    this.pageInfo.setTotalRecords(data.total);
    this.tenantId = data.tenantId;
    this.tenantName = data.tenantName;
    this.schedules = map(function(item) {
      return new SchedulingSearchRow(item);
    }, data.result);
  });

  /**
   * Update selected for whole grid
   * @param {string} value
   */
  SchedulingSearchGrid.prototype.updateSelected = action(function(value) {
    this.schedules.forEach(function(schedule) {
      schedule.updateSelected(value);
    });
  });

  /**
   * Check duplicate schedule name in one grid
   * @param {object} schedule
   * @returns {boolean}
   */
  SchedulingSearchGrid.prototype.checkDuplicateScheduleName = function(schedule) {
    return (
      findIndex(function(item) {
        var name = item.getDataByKey('name');
        return (
          name &&
          schedule.name &&
          name.toUpperCase() === schedule.name.toUpperCase() &&
          item.getDataByKey('id') !== schedule.id &&
          item.getDataByKey('dashboardId') === schedule.dashboardId &&
          item.getDataByKey('reportId') === schedule.reportId
        );
      }, this.schedules) > -1
    );
  };

  /**
   * Set page index for grid
   * @param {number} pageIndex
   */
  SchedulingSearchGrid.prototype.setPageIndex = function(pageIndex) {
    this.pageInfo.setPageIndex(pageIndex);
  };

  /**
   * Set page Size for grid
   * @param {number} pageSize
   */
  SchedulingSearchGrid.prototype.setPageSize = action(function(pageSize) {
    this.pageInfo.setPageSize(pageSize);
    this.pageInfo.setPageIndex(1);
  });

  /**
   * Set column sort
   * @param {string} key
   * @param {string} sortType
   */
  SchedulingSearchGrid.prototype.setColSortDirs = function(key, sortType) {
    this.pageInfo.setColSortDirs(key, sortType);
  };

  /**
   * Delete a schedule
   * @param {object} schedule
   */
  SchedulingSearchGrid.prototype.deleteSchedule = action(function(schedule) {
    var index = findIndex({ id: schedule.id }, this.schedules);
    if (index > -1) {
      this.schedules.splice(index, 1);
      this.pageInfo.descreaseRecord();
    }
  });

  /**
   * Delete selected schedules
   */
  SchedulingSearchGrid.prototype.deleteSelectedSchedules = action(function() {
    var numberSelectedSchedules = this.schedules.filter(function(item) {
      return item.selected;
    }).length;
    this.schedules = this.schedules.filter(function(item) {
      return !item.selected;
    });
    var pageInfo = this.pageInfo;
    times(pageInfo.descreaseRecord.bind(pageInfo), numberSelectedSchedules);
  });

  module.exports = SchedulingSearchGrid;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SchedulingSearchGrid.js